<app-page-heading [title]="formTitle" [subheadingIcon]="'fa fa-truck'"></app-page-heading>

<section class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-4">
                    <button type="button" class="btn btn-primary btn-outline btn-lg pull-left" (click)="location.back()">
                        <span class="fa fa-arrow-left"> </span>
                    </button>&nbsp;
                </div>
                <div class="col-xs-8 text-right" *ngIf="formType == FormTypes.UPDATE">
                    <app-dropdown-button [btnTextKey]="'user-dashboard.carriers.form.actions.label'"
                        class="pull-right">
                        <li app-dropdown-button-item (click)="toggleBlockingCarrier()">
                            <i class="fa fa-ban m-r-xxs"></i>
                            <span [i18n]="[{target: 'innerHTML', key: (carrier.blocked ? 'user-dashboard.carriers.form.actions.unblock' : 'user-dashboard.carriers.form.actions.block')}]"></span>
                        </li>
                        <li app-dropdown-button-item *ngIf="bluechatEnabled && !isBluechatActivated && carrier.eligibleToBluechatActivation" (click)="openEnableBluechatModal()">
                            <i class="fa fa-comments"></i> <span [i18n]="'bluechat.activate'"></span>
                        </li>
                    </app-dropdown-button>
                    <bluechat-badge  class="pull-right" [bluechatActivated]="isBluechatActivated"
                                     *ngIf="bluechatEnabled && formType !== FormTypes.CREATE && (carrier.eligibleToBluechatActivation || isBluechatActivated)">
                    </bluechat-badge>
                </div>
            </div>

            <br>

            <div class="ibox float-e-margins">
                <div class="ibox-title border-primary">
                    <div class="row">
                        <h5 class="col-xs-12">
                            <span *ngIf="carrier.name" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.title-with-name',
                                  params: { name: carrier.name }}]"></span>
                            <span *ngIf="!carrier.name" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.title'}]"></span>
                        </h5>
                    </div>
                </div>
                <div class="ibox-content">
                    <form #carrierForm="ngForm" (submit)="processForm()" novalidate class="row">
                        <fieldset [disabled]="formProcessingBlocked || carrier.blocked" class="col-xs-12">
                            <div class="alert alert-warning" *ngIf="carrier.blocked">
                                <i class="fa fa-warning"></i>
                                <em [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.warnings.blocked'}]"></em>
                            </div>

                            <div class="form-group"
                                 [ngClass]="{'has-error': carrierName.invalid && mode == DisplayMode.Edition}">
                                <label class="control-label" for="carrier-name" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.name.label'}]"></label>
                                <input #carrierName='ngModel'
                                       class="form-control input-lg" name="carrier-name" id="carrier-name"
                                       type="text"
                                       required
                                       [(ngModel)]="carrier.name" [disabled]="formType == FormTypes.UPDATE_OWN">
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.name.help'}]"></small>
                            </div>

                            <div class="form-group"
                                 [ngClass]="{'has-error': carrierCode.invalid && mode == DisplayMode.Edition}">
                                <label class="control-label" for="carrier-code" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.code.label'}]"></label>
                                <input #carrierCode='ngModel'
                                       class="form-control input-lg" name="carrier-code" id="carrier-code" type="text" required
                                       [(ngModel)]="carrier.code" [disabled]="formType === FormTypes.UPDATE_OWN">
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.code.help'}]"></small>
                            </div>

                            <div class="form-group" *ngIf="isBluechatActivated">
                                <label class="control-label" for="bluechat-code" [i18n]="'user-dashboard.carriers.form.bluechat-code.label'"></label>
                                <input class="form-control input-lg" name="bluechat-code" id="bluechat-code" type="text" [value]="carrier.bluechatCarrierCode" [disabled]="true">
                                <small class="help-block m-b-none" [i18n]="'user-dashboard.carriers.form.bluechat-code.help'"></small>
                            </div>

                            <div class="form-group" [ngClass]="{ 'has-error': scacCodeInput.invalid}">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.sap-carrier-codes.title'}]"></label>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.sap-carrier-codes.indication'}]"></small>
                                <div class="row">
                                    <!-- vendor number(s) -->
                                    <div class="col-md-6 col-xs-12" *ngIf="!multipleVendorFlags">
                                        <div class="form-group" [ngClass]="{ 'has-error': vendorNumberInput.invalid }">
                                            <label for="carrier-vendor-number" [i18n]="'user-dashboard.carriers.form.sap-carrier-codes.vendor-number.label'"></label>
                                            <input class="form-control input-lg" name="carrier-vendor-number" id="carrier-vendor-number" type="text"
                                                   [(ngModel)]="carrier.vendorNumber" #vendorNumberInput="ngModel" (keyup)="checkScacCodeAndVendorNumber()"
                                                   [disabled]="formType === FormTypes.UPDATE_OWN">
                                            <small class="help-block-regular m-b-none">
                                                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.sap-carrier-codes.vendor-number.indication'}]"></span>&nbsp;
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-12" *ngIf="multipleVendorFlags">
                                        <div class="form-group">
                                            <label for="carrier-vendor-numbers" [i18n]="'user-dashboard.carriers.form.sap-carrier-codes.vendor-numbers.label'"></label>
                                            <ng-select
                                                    id="carrier-vendor-numbers"
                                                    #vendorNumberInput="ngModel"
                                                    [name]="'carrier-vendor-numbers'"
                                                    [items]="[]"
                                                    [addTag]="true"
                                                    [notFoundText]="'common.not-found-item' | translate"
                                                    [hideSelected]="true"
                                                    [multiple]="true"
                                                    [(ngModel)]="carrier.vendorNumbers"
                                                    (change)="checkScacCodeAndVendorNumber(); carrierForm.form.markAsDirty()"
                                                    [appendTo]="'body'"
                                                    [disabled]="formType === FormTypes.UPDATE_OWN"
                                                    [clearable]="false">
                                            </ng-select>
                                            <small class="help-block-regular m-b-none">
                                                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.sap-carrier-codes.vendor-numbers.indication'}]"></span>&nbsp;
                                            </small>
                                        </div>
                                    </div>

                                    <!-- scac code -->
                                    <div class="col-md-6 col-xs-12">
                                        <div class="form-group" [ngClass]="{ 'has-error': scacCodeInput.invalid && mode == DisplayMode.Edition}">
                                            <label for="carrier-scac-code" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.sap-carrier-codes.scac-code'}]"></label>
                                            <input class="form-control input-lg" name="carrier-scac-code" id="carrier-scac-code" type="text"
                                                   [(ngModel)]="carrier.scacCode" #scacCode #scacCodeInput="ngModel" (keyup)="checkScacCodeAndVendorNumber()"
                                                   [disabled]="formType === FormTypes.UPDATE_OWN">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" [ngClass]="{'has-error': carrierTmsType.invalid && mode == DisplayMode.Edition}">
                                <label class="control-label" for="carrier-tms-type" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.tms-type.label'}]"></label>
                                <select #carrierTmsType='ngModel' class="form-control input-lg m-b" name="carrier-tms-type" id="carrier-tms-type" (change)="changeTmsType()" required
                                        [(ngModel)]="carrier.tmsType" [disabled]="formType == FormTypes.UPDATE_OWN">
                                    <option [ngValue]="TmsType.BLUJAY" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.tms-type.blujay'}]"></option>
                                    <option [ngValue]="TmsType.BLUEYONDER" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.tms-type.blueyonder'}]"></option>
                                    <option [ngValue]="TmsType.LOCAL" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.tms-type.local'}]"></option>
                                </select>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.tms-type.help'}]"></small>
                            </div>


                            <ng-container class="form-group" *ngIf="carrier.tmsType === TmsType.BLUJAY || carrier.tmsType === TmsType.BLUEYONDER">
                                <div [ngClass]="{'has-error': carrierBlujayUrl.invalid && mode == DisplayMode.Edition}" class="form-group" *ngIf="carrier.tmsType === TmsType.BLUJAY">
                                    <label class="control-label" for="carrier-blujay-url" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blujay-url.label'}]"></label>
                                    <div class="input-group">
                                        <div class="input-group-addon"><i class="fa fa-link"></i></div>
                                        <select #carrierBlujayUrl='ngModel'
                                                class="form-control input-lg" name="carrier-blujay-url"
                                                id="carrier-blujay-url" required
                                                [(ngModel)]="carrier.blujayUrl"
                                                [disabled]="formType == FormTypes.UPDATE_OWN">
                                            <option *ngFor="let b of blujayUrls" [ngValue]="b.name">{{b.label}}</option>
                                        </select>
                                    </div>
                                    <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blujay-url.help'}]"></small>
                                </div>

                                <div class="form-group" *ngIf="carrier.tmsType === TmsType.BLUJAY">
                                    <label class="control-label" for="blujayUsername"
                                           [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blujay-username.label'}]"></label>
                                    <div class="input-group">
                                        <div class="input-group-addon"><i class="fa fa-user"></i></div>
                                        <input name="blujayUsername"
                                               type="text"
                                               class="form-control input-lg"
                                               id="blujayUsername"
                                               [(ngModel)]="carrier.blujayCredentials.username"
                                               (change)="carrier.blujayCredentials.username = carrier.blujayCredentials.username.trim()"
                                               aria-describedby="blujayUsernameHelp">
                                    </div>
                                    <small id="blujayUsernameHelp" class="help-block m-b-none"
                                           [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blujay-username.help'}]"></small>
                                </div>

                                <div class="form-group" *ngIf="carrier.tmsType === TmsType.BLUJAY">
                                    <label class="control-label" for="blujayApiToken" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blujay-api-token.label'}]"></label>
                                    <div class="input-group">
                                        <div class="input-group-addon"><i class="fa fa-key"></i></div>
                                        <input name="blujayApiToken" type="text" class="form-control input-lg" id="blujayApiToken"
                                               [(ngModel)]="carrier.blujayCredentials.apiToken" (change)="carrier.blujayCredentials.apiToken = carrier.blujayCredentials.apiToken.trim()"
                                               aria-describedby="blujayApiTokenHelp">
                                    </div>
                                    <small id="blujayApiTokenHelp" class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blujay-api-token.help'}]"></small>
                                </div>

                                <div class="form-group"
                                     [ngClass]="{'has-error': blueyonderCarrierCode.invalid && mode == DisplayMode.Edition}"
                                     *ngIf="carrier.tmsType === TmsType.BLUEYONDER">
                                    <label class="control-label" for="blueyonderCarrierCode"
                                           [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blueyonder-carrier-code.label'}]"></label>
                                    <input #blueyonderCarrierCode=ngModel
                                           name="blueyonderCarrierCode" type="text" class="form-control input-lg"
                                           id="blueyonderCarrierCode"
                                           [(ngModel)]="carrier.blueyonderCarrierCode"
                                           (change)="carrier.blueyonderCarrierCode = carrier.blueyonderCarrierCode.trim()"
                                           aria-describedby="blueyonderCarrierCodeHelp"
                                           required
                                           [disabled]="formType === FormTypes.UPDATE_OWN">
                                    <small id="blueyonderCarrierCodeHelp" class="help-block m-b-none"
                                           [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.blueyonder-carrier-code.help'}]"></small>
                                </div>

                                <div class="form-group">
                                    <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.last-tms-synchronization.label'}]"></label>
                                    <div class="input-group">
                                        <div class="input-group-addon"><i class="fa fa-clock"></i></div>
                                        <input *ngIf="carrier.lastTmsSynchronization" name="lastTmsSynchronization" type="text" class="form-control input-lg" readonly
                                               [value]="carrier.lastTmsSynchronization | dateDiffFromNow | async" aria-describedby="lastTmsSynchronizationHelp">
                                        <input *ngIf="!carrier.lastTmsSynchronization" name="lastTmsSynchronization" type="text" class="form-control input-lg" readonly
                                               [i18n]="[{target: 'attribute:value', key: 'user-dashboard.carriers.form.last-tms-synchronization.never'}]" aria-describedby="lastTmsSynchronizationHelp">
                                    </div>
                                    <small id="lastTmsSynchronizationHelp" class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.last-tms-synchronization.help'}]"></small>
                                </div>
                            </ng-container>

                            <div class="form-group" *ngIf="mode !== DisplayMode.Creation">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.cmbl-api-token.label'}]"></label>
                                <div class="input-group">
                                    <div class="input-group-addon"><i class="fa fa-key"></i></div>
                                    <input readonly name="cmblApiToken" type="text" class="form-control input-lg" id="cmblApiToken"
                                           [(ngModel)]="carrier.cmblApiToken" (change)="carrier.cmblApiToken = carrier.cmblApiToken.trim()"
                                           aria-describedby="cmblApiTokenHelp">
                                </div>
                                <small id="cmblApiTokenHelp" class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.cmbl-api-token.help'}]"></small>
                            </div>

                            <div [ngClass]="{'has-error': carrierRegion.invalid && mode == DisplayMode.Edition}" class="form-group" *ngIf="formType != FormTypes.UPDATE_OWN">
                                <label class="control-label" for="carrier-region" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.region.label'}]"></label>
                                <select #carrierRegion='ngModel' class="form-control input-lg m-b" name="carrier-region" id="carrier-region" required [compareWith]="equalsRegionsId"
                                        [(ngModel)]="carrier.region" [disabled]="formType === FormTypes.UPDATE_OWN" (change)="regionChanged()">
                                    <option *ngFor="let region of regions" [ngValue]="region">{{ region.name }}</option>
                                </select>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.region.help'}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" [i18n]="'user-dashboard.carriers.form.email.label'"></label>
                                <app-data-filter-form-autocomplete
                                    [name]="'contactEmails'"
                                    [notFoundTextKey]="'regions.form.contact-email.notfound' | translate"
                                    [(model)]="carrier.emails"
                                    (modelChange)="carrierForm.form.markAsDirty()"
                                    [multiple]="true">
                                </app-data-filter-form-autocomplete>
                                <small class="help-block m-b-none" [i18n]="'user-dashboard.carriers.form.email.help-new'"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.preferred-timezone.label'}]"></label>
                                <ng-select
                                    [items]="timezones"
                                    [clearable]="true"
                                    [name]="'carrier-preferred-timezone'"
                                    [addTag]="false"
                                    [hideSelected]="false"
                                    [i18n]="[{target: 'attribute:placeholder', key: carrier.region ? 'user-dashboard.carriers.form.preferred-timezone.placeholder' : ' ',
                                            params: carrier.region ? { regionValue: carrier.region.preferredTimezone } : {}}]"
                                    [(ngModel)]="carrier.preferredTimezone">
                                </ng-select>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.preferred-timezone.help'}]"></small>
                            </div>

                            <div class="form-group" [ngClass]="{ 'has-error': preferredLanguageSelect.invalid }">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.preferred-language.label'}]"></label>
                                <ng-select [name]="'carrier-preferred-language'"
                                           [items]="languages"
                                           [(ngModel)]="carrier.preferredLocale"
                                           (clear)="checkPreferredLanguageNotEmpty()"
                                           [bindValue]="'value'"
                                           [bindLabel]="'label'"
                                           #preferredLanguageSelect="ngModel">
                                </ng-select>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.preferred-language.help'}]"></small>
                            </div>

                            <div class="form-group"
                                 [ngClass]="{'has-error': thirdPartyCarrier.invalid && mode == DisplayMode.Edition }"
                                 *ngIf="canSeeApiFamilyOption">
                                <label class="control-label" [i18n]="'user-dashboard.carriers.form.third-party.label'"></label>
                                <ng-select #thirdPartyCarrier='ngModel'
                                           [name]="'third-party-carrier'"
                                           [(ngModel)]="carrier.apiFamily"
                                           [clearable]="false"
                                           [required]="true">
                                    <ng-option *ngFor="let option of apiFamilyOptions" [value]="option.value" [i18n]="option.labelKey"></ng-option>
                                </ng-select>
                            </div>

                            <div class="form-group" *ngIf="canManageCarrierFeatureProfile()">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.feature-profile.label'}]"></label>

                                <small id="featureProfilesNote" class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.feature-profile.note'}]"></small>

                                <div class="row">
                                    <app-feature-profile-editor [featureProfile]="carrier.featureProfile"
                                                                [regionFeatures]="carrier.region.features"
                                                                [showError]="mode == DisplayMode.Edition"
                                                                [form]="carrierForm"
                                                                (errorMessageKeyEmitter)="formErrorMessageKey = $event">
                                    </app-feature-profile-editor>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="tmsLoadsSynchronizationRequired">
                                <div class="alert alert-warning">
                                    <i class="fa fa-exclamation-triangle"></i>
                                    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.warnings.tms-synchronization-required'}]"></span>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="carrier.featureProfile.tmsLoadsSynchronization">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.tms-load-pick-start-date.label'}]"></label>

                                <div class="tms-pick-date-container">
                                    <div class="tms-pick-date">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" name="tms-sync-name" [(ngModel)]="carrier.tmsPickStartDateRequired">
                                                <i class="fa checkbox-icon"></i>
                                                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.tms-load-pick-start-date.label-1'}]"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="tms-pick-date" [ngClass]="{ 'has-error': tmsPickStartDateInput.invalid }">
                                        <input type="hidden" name="tmsLoadPickStartDateValidation" [(ngModel)]="tmsPickStartDate" [required]="carrier.tmsPickStartDateRequired">
                                        <input class="form-control" name="tmsLoadPickStartDate" #tmsPickStartDateInput="ngModel"
                                               [dpDayPicker]="config" [theme]="'date-time-picker'"
                                               [(ngModel)]="tmsPickStartDate" mode="daytime" (ngModelChange)="updatePickStartDate()">
                                    </div>
                                    <div class="tms-pick-date m-l-sm">
                                         <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.tms-load-pick-start-date.label-2'}]"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.loads-range.label'}]"></label>
                                <div class="alert alert-info">
                                    <i class="fa fa-info-circle"></i>
                                    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.loads-range.notice-1'}]"></span>
                                </div>
                                <div class="radio">
                                    <label *ngFor="let loadRange of loadRangeOptions">
                                        <input type="radio" [value]="loadRange.value" name="loadRanges"  [(ngModel)]="carrier.loadsFetchRange">
                                        <i class="fa radio-icon"></i>
                                        <span [i18n]="[{target: 'innerHTML', key: loadRange.labelKey }]"></span>
                                    </label>
                                </div>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.loads-range.notice-2'}]"></small>
                            </div>

                            <div class="form-buttons pull-right">
                                <button (click)="checkBlujayCredentials($event)" class="btn btn-warning  btn-lg"
                                        *ngIf="carrier.tmsType === TmsType.BLUJAY"
                                        [disabled]="!carrier.blujayCredentials.username || !carrier.blujayCredentials.apiToken">
                                    <span class="fa fa-check space-right-5"></span>
                                    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.form.buttons.verify'}]"></span>
                                </button>
                                <div class="form-error" *ngIf="carrierForm.invalid && mode == DisplayMode.Edition && !formErrorMessageKey"
                                      [i18n]="'user-dashboard.carriers.form.error'"></div>
                                <div class="form-error" *ngIf="carrierForm.invalid && formErrorMessageKey"
                                      [i18n]="formErrorMessageKey"></div>
                                <button type="submit" class="btn btn-primary btn-lg"
                                        [disabled]="carrierForm.invalid || carrierForm.pristine">
                                    <span class="fa fa-save space-right-5"></span>
                                    <span [i18n]="[{target: 'innerHTML', key: mode == DisplayMode.Creation ? 'user-dashboard.carriers.form.buttons.create' :  'user-dashboard.carriers.form.buttons.update'}]"></span>
                                </button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #blueChatTemplate let-users="users">
    <div class="alert alert-info small blueChatCode">
        <div class="row text-center" style="width: 100%">
            <div class="col-xs-12">
                <i class="fa fa-info-circle m-r-xs"></i>
                <span [i18n]="'bluechat.modal.carrier.existing-carrier-label'"></span><br>
            </div>
            <div class="col-xs-12">
                <div class="row">
                    <div class="col-xs-2"></div>
                    <div class="col-xs-8 alignLabelCode">
                        <span [i18n]="'bluechat.modal.carrier.code-input-label'"></span>
                        <input class="form-control" [(ngModel)]="modalBluechatCode">
                    </div>
                    <div class="col-xs-2"></div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <span class="m-b-md" [i18n]="'bluechat.modal.carrier.user-select'"></span>

        <ng-select [multiple]="true"
                   [bindLabel]="'email'"
                   [items]="users"
                   [(ngModel)]="selectedUsersToCreateInBluechat">
        </ng-select>
    </div>
</ng-template>
